import request from "@/api/request";

export function getRealTimeWeather(params) {
    return request({
        url: '/api/weather/getWeather',
        method: 'get',
        params: params,
    });
}
